module.exports = __webpack_public_path__ + "img/9_wind.ffb6d6f0.jpg";